// extracted by mini-css-extract-plugin
export default {"subtitle":"yc2EXl"};